var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSparkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48636_7452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1655 7.01465L11.544 6.17625L12.3824 5.79777C12.5693 5.71154 12.5693 5.44804 12.3824 5.3618L11.544 4.98333L11.1655 4.14013C11.0793 3.95329 10.8158 3.95329 10.7296 4.14013L10.3511 4.97854L9.50791 5.35701C9.32106 5.44325 9.32106 5.70675 9.50791 5.79298L10.3463 6.17146L10.7248 7.01465C10.811 7.2015 11.0793 7.2015 11.1655 7.01465ZM7.35202 7.73328L6.59027 6.05648C6.42259 5.68279 5.88601 5.68279 5.71833 6.05648L4.95658 7.73328L3.27978 8.49503C2.90609 8.6675 2.90609 9.19929 3.27978 9.36697L4.95658 10.1287L5.71833 11.8055C5.8908 12.1792 6.42259 12.1792 6.59027 11.8055L7.35202 10.1287L9.02882 9.36697C9.40251 9.1945 9.40251 8.66271 9.02882 8.49503L7.35202 7.73328ZM10.7248 10.8473L10.3463 11.6858L9.50791 12.0642C9.32106 12.1505 9.32106 12.414 9.50791 12.5002L10.3463 12.8787L10.7248 13.7219C10.811 13.9087 11.0745 13.9087 11.1608 13.7219L11.5392 12.8835L12.3824 12.505C12.5693 12.4188 12.5693 12.1553 12.3824 12.069L11.544 11.6905L11.1655 10.8473C11.0793 10.6605 10.811 10.6605 10.7248 10.8473Z",
    fill: "#6B7684"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48636_7452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkIcon);
export default __webpack_public_path__ + "static/media/SparkIcon.a13bf3e3f70cc2950184708a819df182.svg";
export { ForwardRef as ReactComponent };